import { LocalStorage } from 'quasar'

export default function () {
  return {
    loading: false,
    table: false,
    selected: false,
    all: [],
    pin: LocalStorage.has('tables.pin') ? LocalStorage.getItem('tables.pin') : '',
    presetTableId: LocalStorage.has('tables.preset') ? LocalStorage.getItem('tables.preset') : '',
  }
}
